module.exports = __webpack_public_path__ + "img/熊猫-2.24c11ebb.png";